import SHA256 from "crypto-js/sha256";

export function generateSHA256(input) {
  return SHA256(input).toString();
}
